<style scoped lang="less">
.layout{position: absolute; background: rgba(2, 36 ,38,.5);-webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2)); filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));overflow: hidden;bottom: 12px;width: 250px;height: 65px;top: 110px;left: 390px;transform: translate(-50%, -50%);border: 1px solid #23fffc;border-radius: 10px;}
.title{height: 35px;background: rgba(33, 185, 191, 0.6);margin: 0;line-height: 35px;text-align: right;padding: 0 20px;color: #fff; font-size: 16px;display: flex;justify-content: space-between;}
.popup-tool {height: 45px;line-height: 45px;color: #fff; font-family: Microsoft YaH;text-align: left;padding: 0px 10px;border:solid 1px rgb(33, 185, 191)}
.popup-content {color: #d6d4d4; font-family: Microsoft YaH;text-align: left;padding: 5px;border-top: none;}
.ol-popup-closer:after {content: "✖";}
/deep/.el-input.is-disabled .el-input__inner {background: rgba(10, 17, 43, 0.4);border: solid 1px #3c818d;}
/deep/.el-select .el-input.is-disabled .el-input__inner:hover {border: solid 1px #3c818d;}
/deep/.el-form-item__label {padding: 0;}
/deep/.el-form-item {margin-bottom: 5px;}
/deep/.el-input {width: 65px;}
/deep/.el-input__inner {width: 65px;}
.determine {cursor: pointer;height: 30px;width: 150px;display: inline-block;line-height: 30px;color: #23fffc;}
.el-radio {color: #fff;}
</style>

<template>
  <div class="layout" v-drag v-if="flag">
    <p class="title">
      <span>查询类型选择</span>
      <a href="#" id="popup-closer" class="ol-popup-closer" @click="closePul(false)"></a>
    </p>
    <div class="popup-content">
      <el-radio v-model="radio" label="Poi" @change='determine'>地名查询</el-radio>
      <el-radio v-model="radio" label="Kyq" @change='determine'>矿业权查询</el-radio>
    </div>
  </div>
</template>

<script>
export default {
  data()
  {
    return {
      radio: 'Kyq',
      flag: false
    }
  },
  methods:
  {
    //关闭插件
    closePul(show)
    {
      this.flag = show
    },
    determine(lable)
    {
      this.$store.commit('searchtype', this.radio)
      this.flag = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/Radio.vue